import { BaseModel } from "./base-model";

export default class MOrderListItem {
    id: string;
    no: string;
    identity: string;
    contact: {
        name: string;
        id: string;
    };
    account: {
        name: string;
        id: string;
    };
    type: string;
    orderDate: Date;
    salesRep: {
        name: string;
    };
    shipInfo: {
        date: string;
        vendor: string;

    };
    status: {
        name: string;
    };
    csr: {
        id: string
    };
    total: string;
    subtotal: string;
    balance: string;
    userAmount: string;
    paymentStatus: string;
    date: {
        booked: string;
        invoice: string;
        cancellation: string;
    }
    currency: {
        baseCurrencyCode: string;
        baseCurrencySymbol: string;
        customerCurrencyCode: string;
        customerCurrencySymbol: string;
        exchageRateForCustomer: string;
    }
    workOrderDetails: {}
    discountAmountToShow:any;
    shippingDetails:any
    shipping:any
    items = []
    tax = {}
    dueDate: string
    customerPo: string
    lateFee: number;
    inhandDate: number;
    kanbanStatusArray: Array<any>;
    constructor(options) {
        this.id = options.id || "";
        this.no = options.no || "";
        this.total = options.total || "";
        this.subtotal = options.subtotal || "";
        this.balance = options.balance || "";
        this.userAmount = options.balance || "";
        this.paymentStatus = options.paymentStatus || "";
        this.currency = {
            baseCurrencyCode: options.currency ? options.currency.baseCurrencyCode : "",
            baseCurrencySymbol: options.currency ? options.currency.baseCurrencySymbol : "",
            customerCurrencyCode: options.currency ? options.currency.customerCurrencyCode : "",
            customerCurrencySymbol: options.currency ? options.currency.customerCurrencySymbol : "",
            exchageRateForCustomer: options.currency ? options.currency.exchageRateForCustomer : ""
        }
        this.identity = options.identity || "";
        if (options.contact) {
            this.contact = {
                name: options.contact.name || "",
                id: options.contact.name || "",
            };
        } else {
            options.contact = {
                name: "",
                id: ""
            }
        }
        if (options.account) {
            this.account = {
                name: options.account.name,
                id: options.account.id
            }
        } else {
            this.account = {
                name: "",
                id: ""
            }
        }
        this.type = options.type || "";
        this.orderDate = options.orderDate || "";
        this.salesRep = options.salesRep ? {
            name: options.salesRep.name
        } : {
            name: ""
        };
        this.shipInfo = options.shipInfo ? {
            date: options.shipInfo.date || "",
            vendor: options.shipInfo.vendor || ""
        } : {
            date: "",
            vendor: ""
        }
        this.status = options.status ? {
            name: options.status.name
        } : {
            name: ""
        }
        this.csr = options.csr ? {
            id: options.csr.id
        } : {
            id: ""
        }
        this.date = {
            booked: options.date ? options.date.booked : "",
            invoice: options.date ? options.date.invoice : "",
            cancellation: options.date ? options.date.cancellation : ""
        }
        this.workOrderDetails = (options.workOrderDetails && options.workOrderDetails.length != 0) ? options.workOrderDetails : null
        this.discountAmountToShow = options.discountAmountToShow || 0
        this.shippingDetails = (options.shippingDetails && options.shippingDetails.length != 0) ? options.shippingDetails : []
        this.customerPo = options.customerPo || ""
        this.lateFee = options.lateFee || 0
        this.inhandDate = options.inhandDate || 0
        this.kanbanStatusArray = options.kanbanStatusArray || []
        this.shipping = options.shipping || {}
        this.items = options.items || []
        this.tax = options.tax || {  }
        this.dueDate = options.dueDate || ""
    }

}
